module.exports = "/_next/static/images/High_Protein-f2e101834b960a97f1e430d49f7e8af3.png";